import { useCallback, useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

async function fetchProductionIncidentSummary(queryString) {
  const url = `${QUALITY_SERVICE_API_URL}/hub/production-incidents/summary?${queryString}`;
  const response = await api.get(url);
  return response.data;
}

function useProductionIncidentSummary(filters, dateRange) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const formatDate = date => {
    if (!date) return null;
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  };

  const fetchSummary = useCallback(async (isCancelled = () => false) => {
    if (!dateRange?.startDate || !dateRange?.endDate) {
      setData(null);
      setLoading(false);
      return;
    }

    const params = new URLSearchParams();
    ['domain', 'group', 'unit'].forEach(key => {
      (filters?.[key] || []).forEach(value => params.append(key, value));
    });

    const fromStr = formatDate(dateRange.startDate);
    if (fromStr) params.set('from', fromStr);
    const toStr = formatDate(dateRange.endDate);
    if (toStr) params.set('to', toStr);

    const queryString = params.toString();

    setLoading(true);
    setError(null);
    setData(null);
    try {
      const summary = await fetchProductionIncidentSummary(queryString);
      if (!isCancelled()) setData(summary);
    } catch (err) {
      if (!isCancelled()) setError(err);
    } finally {
      if (!isCancelled()) setLoading(false);
    }
  }, [filters, dateRange]);

  useEffect(() => {
    let cancelled = false;
    fetchSummary(() => cancelled);
    return () => { cancelled = true; };
  }, [fetchSummary]);

  return { data, loading, error, refetch: () => fetchSummary() };
}

export default useProductionIncidentSummary;
